import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuid } from 'uuid';

export function copyPromoDiscount(discount: App.PromoDiscount, newId = uuid()): App.PromoDiscount {
  return {
    ...cloneDeep(discount),
    id: newId,
    id_promo_code_discount: newId,
    isNew: true,
    modified_by: '',
    created_at: '',
    updated_at: '',
  };
}
